<ng-container *ngIf="additionalServiceDetail && additionalServiceDetail.appointmentAdditionalDemandList?.length>0">


    <div class="row justify-content-center pb15">

        <div class="col-10 col-sm-10 col-md-11 col-lg-10 text-right">
            <button type="button" class="btn btn-primary " *ngIf="approveAll && currentAppointment.IsActiveAppointment"
                (click)="ApproveAllAdditionalDemand(AllApprovedcommentContent)" translate>
                lblApproveAll
            </button>
        </div>

    </div>
    <div class="row justify-content-center">

        <div class="col-12 col-sm-12 col-md-11 col-lg-10">
            <div class="bg-light p-3 jobBlock"
                *ngFor="let job of additionalServiceDetail.appointmentAdditionalDemandList; let i=index">
                <div class="alert alert-warning mb-2 font18 text-center"
                    *ngIf="job.isCustomerApporved===0 && job.canBeDoneNow && job.isMechanicApproved === 0 && job.isAdminApproved === 0 && job.isCDSSApproved === 0 && (repairStatusId!==7 && repairStatusId!==9 && repairStatusId!==10)">
                    <em class="fa fa-exclamation-triangle font22 vm mr-1"></em> <span
                        translate>lblNeedPriorApproval</span>
                </div>
                <div class="alert alert-warning mb-2 font18 text-center"
                    *ngIf="(repairStatusId===7 || repairStatusId===9 || repairStatusId===10) && job.isCustomerApporved===0 && job.canBeDoneNow && job.isMechanicApproved === 0 && job.isAdminApproved === 0 && job.isCDSSApproved === 0">
                    <em class="fa fa-exclamation-triangle font22 vm mr-1"></em> <span
                        translate>lblDemandNotApproved</span>
                </div>
                <div>
                    <div class="d-flex "
                        *ngIf="job.isCustomerApporved===1 || job.isAdminApproved===1 || job.isCDSSApproved === 1 || job.isMechanicApproved === 1">
                        <p class="h5 font16 font-weight-bold">
                            <em class="fa fa-check-circle text-success"></em> {{job.shortDescription}}
                        </p>
                        <p *ngIf="job.hidePrice != 1" class="h5 font16 text-success font-weight-bold ml-auto pl-2">
                            {{(job.isUnderWarranty ? '' : job.sumPerServiceInclTax | number:'1.2-2')}}
                        </p>
                    </div>
                    <div class="d-flex "
                        *ngIf="job.isCustomerApporved===-1 || job.isAdminApproved===-1 || job.isCDSSApproved === -1 || job.isMechanicApproved === -1">
                        <p class="h5 font16 font-weight-bold">
                            <em class="fa fa-ban text-danger"></em> {{job.shortDescription}}
                        </p>
                        <p *ngIf="!job.hidePrice  != 1" class="h5 font16 text-danger font-weight-bold ml-auto pl-2">
                            {{(job.isUnderWarranty ? '' : job.sumPerServiceInclTax | number:'1.2-2')}}
                        </p>
                    </div>
                    <div class="d-flex "
                        *ngIf="(job.isCustomerApporved===0 && job.isAdminApproved===0 && job.isCDSSApproved === 0 && job.isMechanicApproved === 0) && job.canBeDoneNow">
                        <p class="h5 font16 font-weight-bold">
                            <em class="fa fa-exclamation-circle text-warning "></em> {{job.shortDescription}}
                        </p>
                        <p *ngIf="job.hidePrice != 1" class="h5 font16 text-warning font-weight-bold ml-auto pl-2">
                            {{(job.isUnderWarranty ? '' : job.sumPerServiceInclTax | number:'1.2-2')}}
                        </p>
                    </div>


                </div>

                <p>
                    {{job.customerRequirement}}
                </p>

                <div class="row justify-content-center" *ngIf="job.demandFiles && job.demandFiles.length>0 && !job.isUnderWarranty">
                    <div class="col-12 col-sm-12 col-md-11 col-lg-6">
                        <ngb-carousel>
                            <ng-template ngbSlide *ngFor="let demandFile of job.demandFiles">
                                <div class="picsum-img-wrapper text-center">
                                    <img width="100%" af-image [data-code]="demandFile.path" alt="image" *ngIf="demandFile.fileType==='image'">
                                    <img width="100%" src="/assets/audio-icon.png" alt="audio" *ngIf="demandFile.fileType==='audio'">
                                    <img width="100%" src="/assets/video.png" alt="video" *ngIf="demandFile.fileType==='video'">
                                    <img width="100%" src="/assets/PDF_icon.png" alt="document" *ngIf="demandFile.fileType==='document'">
                                </div>
                                <button type="button" class="btn btn-outline-primary my-3" (click)="downloadFile(demandFile.path);">
                                    <em class="fas fa-download fa-lg mr-2"></em>
                                    <span translate>lblDownload</span>
                                </button>
                            </ng-template>
                        </ngb-carousel>
                    </div>
                </div>

                <div *ngIf="repairStatusId!==7 && repairStatusId!==9 && repairStatusId!==10">
                    <div class="btn-section" *ngIf="(job.isCustomerApporved===0 && job.canBeDoneNow && job.isMechanicApproved === 0 && job.isAdminApproved === 0 && job.isCDSSApproved === 0) || 
                (job.isCustomerApporved===-1  && (showData && job.id === buttonJobID))">
                        <hr>
                        <div class="d-block d-md-flex align-items-center">
                            <div class="font-weight-bold text-nowrap d-flex align-items-center">
                                <span translate>lblWantToKnowMore</span> <a href="tel:{{dealerPhone}}"
                                    class="font-weight-bold btn btn-link d-inline-flex align-items-center"
                                    (click)="CallDealerLogEntry()"><em
                                        class="fa fa-phone-square mx-1 font22 align-middle" aria-hidden="true"
                                        translate></em><span translate>lblCallDealer</span></a>
                            </div>
                            <div class="ml-auto">

                                <button type="button" class="btn btn-primary " *ngIf ="currentAppointment.IsActiveAppointment" (click)="onApprove(commentContent,job)"
                                    translate>lblApprove</button>
                                <button type="button" class="btn btn-outline-secondary ml-2"  *ngIf ="currentAppointment.IsActiveAppointment"
                                    (click)="onReject(RejectcommentContent,job)" translate>lblReject</button>


                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="font-weight-bold d-flex my-2 col-8">
                        <span>
                            <span class="text-danger" translate
                                *ngIf="job.isAdminApproved===-1 || job.isCDSSApproved===-1 || job.isMechanicApproved===-1">
                                <span class="mr-4">{{job.approvalDate | date:'short'}}</span>
                                <em class="fa fa-ban mr-2 align-top mt-1 "></em> lblRejectByWorkShop
                            </span>
                            <span class="text-success" translate
                                *ngIf="job.isAdminApproved===1 || job.isCDSSApproved===1 || job.isMechanicApproved===1">
                                <span class="mr-4">{{job.approvalDate | date:'short'}}</span>
                                <span class="d-inline-flex align-items-center text-nowrap" translate>
                                    <em _ngcontent-jeq-c139="" class="fa fa-check-circle text-success mr-2"></em>
                                    lblApproveByWorkShop
                                </span>
                            </span>
                            <span class="text-danger" translate *ngIf="job.isCustomerApporved===-1">
                                <span class="mr-4">{{job.approvalDate | date:'short'}}
                                </span>
                                <em class="fa fa-ban mr-2 align-top mt-1 "></em> lblRejectedByCustomer
                                <br>
                                <div translate class="comment">
                                    <p>{{job.comment}}</p>
                                </div>

                            </span>
                            <span class="text-success" translate *ngIf="job.isCustomerApporved===1">
                                <span class="mr-4">{{job.approvalDate | date:'short'}}
                                </span>
                                <em class="fa fa-check-circle text-success align-top mt-1 "></em> lblApprovedByCustomer
                                <br>
                                <div translate class="comment">
                                    <p>{{job.comment}}</p>
                                </div>
                            </span>
                        </span>



                    </div>
                    <div class="col-4 my-2 " *ngIf="job.isCustomerApporved===-1 && currentAppointment.IsActiveAppointment">
                        <a class="btn-link ml-auto font-weight-bold   changeBtn" (click)="ShowButton(job)" translate>
                            lblChange
                        </a>
                    </div>
                </div>

            </div>


        </div>
    </div>
</ng-container>
<ng-container *ngIf="noRecords">
    <div class="row justify-content-center">
        <div class="col-12 col-sm-12 col-md-11 col-lg-10">
            <div translate class="alert alert-warning mb-2 font18 text-center">lblNoAdditionalServices</div>
        </div>
    </div>
</ng-container>





<ng-template #commentContent let-modal>

    <div class="modal-header">
        <h2 class="modal-title" translate>lblAreYouSureWantToApprove</h2>
        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss(false)">
            <span aria-hidden="true">×</span>
        </button>
    </div>

    <div class="modal-body ">
        <div class="popup-vcenter ">
            <div>
                <div>
                    <ng-container>
                        <label translate>lblComment</label>
                        <textarea type="text" id="form8" [(ngModel)]="comments" class="form-control">
                </textarea>
                    </ng-container>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-primary" (click)="modal.dismiss(true)" translate>lblYes</button>
        <button type="button" class="btn btn-secondary" (click)="modal.dismiss(false)" translate>lblNot</button>
    </div>
</ng-template>

<ng-template #RejectcommentContent let-modal>

    <div class="modal-header">
        <h2 class="modal-title" translate>lblAreYouSureWantToReject</h2>
        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss(false)">
            <span aria-hidden="true">×</span>
        </button>
    </div>

    <div class="modal-body ">
        <div class="popup-vcenter ">
            <div>
                <div>
                    <ng-container>
                        <label translate>lblComment</label>
                        <textarea type="text" id="form8" [(ngModel)]="comments" class="form-control">
                  </textarea>
                    </ng-container>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-primary" (click)="modal.dismiss(true)" translate>lblYes</button>
        <button type="button" class="btn btn-secondary" (click)="modal.dismiss(false)" translate>lblNot</button>
    </div>
</ng-template>

<ng-template #AllApprovedcommentContent let-modal>

    <div class="modal-header">
        <h2 class="modal-title" translate>lblAreYouSureWantToApprove</h2>
        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss(false)">
            <span aria-hidden="true">×</span>
        </button>
    </div>

    <div class="modal-body ">
        <div class="popup-vcenter ">
            <div>
                <div>
                    <ng-container>
                        <label translate>lblComment</label>
                        <textarea type="text" id="form8" [(ngModel)]="Allcomments" class="form-control">
                </textarea>
                    </ng-container>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-primary" (click)="modal.dismiss(true)" translate>lblYes</button>
        <button type="button" class="btn btn-secondary" (click)="modal.dismiss(false)" translate>lblNot</button>
    </div>
</ng-template>